var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Modal",
    {
      attrs: { visible: _vm.visible },
      on: {
        "close-modal": function ($event) {
          return _vm.$emit("close-modal")
        },
      },
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", [_vm._v("Search Help")]),
          _c("v-card-text", [
            _c("h3", [_vm._v("Filter your controls via advanced search.")]),
            _c("br"),
            _c("h2", [_vm._v("Supported Query Examples")]),
            _c("h4", [_vm._v("Queries are not case-sensitive")]),
            _c("br"),
            _c("ul", [
              _c("li", { staticClass: "pb-1" }, [
                _c("h3", [_vm._v("ID: "), _c("code", [_vm._v("id:V-123456")])]),
              ]),
              _c("li", { staticClass: "pb-1" }, [
                _c("h3", [
                  _vm._v("Title: "),
                  _c("code", [_vm._v("title:Server")]),
                ]),
              ]),
              _c("li", { staticClass: "pb-1" }, [
                _c("h3", [
                  _vm._v("Severity: "),
                  _c("code", [_vm._v("severity:High")]),
                ]),
              ]),
              _c("li", { staticClass: "pb-1" }, [
                _c("h3", [
                  _vm._v("Status: "),
                  _c("code", [_vm._v("status:Passed")]),
                ]),
              ]),
              _c("li", { staticClass: "pb-1" }, [
                _c("h3", [
                  _vm._v("NIST 800-53: "),
                  _c("code", [_vm._v("nist:UM-1")]),
                ]),
              ]),
              _c("li", { staticClass: "pb-1" }, [
                _c("h3", [
                  _vm._v("Description: "),
                  _c("code", [_vm._v('desc:"Status groups"')]),
                ]),
              ]),
              _c("li", { staticClass: "pb-1" }, [
                _c("h3", [
                  _vm._v(" Code: "),
                  _c("code", [
                    _vm._v('code:"Ensure enable log file validation is set"'),
                  ]),
                ]),
              ]),
              _c("li", { staticClass: "pb-1" }, [
                _c("h3", [
                  _vm._v("Inputs: "),
                  _c("code", [_vm._v("input:disable_slow_controls")]),
                ]),
              ]),
              _c("li", { staticClass: "pb-1" }, [
                _c("h3", [
                  _vm._v("Tags: "),
                  _c("code", [_vm._v("tags:severityoverride")]),
                ]),
              ]),
            ]),
            _c("br"),
            _c("h2", [_vm._v("Joining Queries")]),
            _c("br"),
            _c("h3", [
              _vm._v(
                " Heimdall supports joining queries. For example, load the AWS CIS Foundations Baseline example and search: "
              ),
            ]),
            _c("br"),
            _c("h3", [
              _c("code", [
                _vm._v(
                  ' status:"Failed,Not reviewed" severity:High title:"Ensure IAM" '
                ),
              ]),
            ]),
          ]),
          _c("v-divider"),
          _c(
            "v-card-actions",
            [
              _c(
                "v-btn",
                {
                  attrs: { color: "primary", text: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close-modal")
                    },
                  },
                },
                [_vm._v(" Close Window ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }